// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const frosmoth: PokeData = {
  "id": 873,
  "name": "frosmoth",
  "height": 13,
  "weight": 420,
  "base_experience": 166,
  "types": [
    PokeType.ICE,
    PokeType.BUG
  ],
  "api_moves": [
    "mist",
    "blizzard",
    "aurora-beam",
    "stun-spore",
    "powder-snow",
    "icy-wind",
    "attract",
    "hail",
    "helping-hand",
    "feather-dance",
    "tailwind",
    "bug-buzz",
    "defog",
    "wide-guard",
    "quiver-dance",
    "struggle-bug",
    "infestation",
    "aurora-veil",
    "snowscape"
  ],
  "moves": [
    "blizzard",
    "stun-spore",
    "tailwind",
    "bug-buzz",
    "aurora-veil",
    "ice-punch",
    "ice-wave",
    "chilly-reception",
    "lunge",
    "avalanche",
    "ice-shard",
    "string-shot",
    "signal-spam"
  ],
  "evolution_chain": {
    "id": 455,
    "item": null,
    "species": [
      {
        "name": "snom",
        "order": 872,
        "types": [
          PokeType.ICE,
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "frosmoth",
        "order": 873,
        "types": [
          PokeType.ICE,
          PokeType.BUG
        ],
        "evolves_from_species_id": 872,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 110,
    "speed": 99,
    "ability_power": 190
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
